<template>
  <div class="law-container">
    <div class="banner">
      <div class="banner-content">
        <div class="banner-content-text">
          <div class="banner-content-text-title">
            {{ translateTitle("MaskEx法律与合规中心") }}
          </div>
          <div class="banner-content-text-subTitle">
            {{
              translateTitle(
                "MaskEx 致力于构建一个安全、合规、透明的全球数字资产交易环境。"
              )
            }}
          </div>
        </div>
        <div class="banner-content-img">
          <img :src="banner" alt="" />
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="section section1">
        <div class="section-title">
          {{ translateTitle("牌照与注册信息") }}
        </div>
        <div class="section-subTitle">
          {{ translateTitle("我们在多个司法辖区依法注册运营，部分示例：") }}
        </div>
        <div class="cards">
          <div v-for="(item, index) in cards" :key="index" class="card">
            <div class="card-country">
              <img :src="item.cIcon" alt="" />
              <span class="card-country-name">{{ item.country }}</span>
            </div>
            <div class="card-name">
              <img :src="item.mIcon" alt="" />
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="section section2">
        <div class="section-title">
          {{ translateTitle("执法请求") }}
        </div>
        <div class="actions">
          <div v-for="(item, index) in actions" :key="index" class="action">
            <div class="action-title">
              <img :src="item.icon" alt="" />
              <span>{{ item.title }}</span>
            </div>
            <div class="steps">
              <div
                v-for="(step, sIndex) in item.steps"
                :key="sIndex"
                class="step"
              >
                <div class="step-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <rect
                      x="-0.00390625"
                      width="18"
                      height="18"
                      rx="9"
                      fill="url(#paint0_linear_132456_198600)"
                    />
                    <path
                      d="M14.4013 6.81838L8.51754 13.4184C8.451 13.5113 8.36328 13.587 8.26165 13.6392C8.16003 13.6914 8.04743 13.7186 7.93318 13.7186C7.81893 13.7186 7.70633 13.6914 7.60471 13.6392C7.50308 13.587 7.41537 13.5113 7.34882 13.4184L4.53118 9.51307C4.51137 9.48611 4.49944 9.45418 4.4967 9.42083C4.49396 9.38749 4.50053 9.35404 4.51567 9.32421C4.53081 9.29437 4.55393 9.26933 4.58246 9.25185C4.61099 9.23438 4.64381 9.22516 4.67727 9.22523H5.7375C5.96893 9.22523 6.1859 9.33661 6.32331 9.52609L7.93173 11.7594L12.6092 6.83139C12.6762 6.73872 12.7642 6.66327 12.866 6.61122C12.9679 6.55917 13.0806 6.53202 13.195 6.53198H14.2552C14.4013 6.53198 14.4866 6.69832 14.4013 6.81838Z"
                      fill="white"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_132456_198600"
                        x1="17.9961"
                        y1="9"
                        x2="-0.00390625"
                        y2="9"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#0084D5" />
                        <stop offset="1" stop-color="#03CF87" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div class="step-content">{{ step }}</div>
                <div
                  class="step-tips"
                  v-if="item.stepTips && item.stepTips[sIndex]"
                >
                  <div
                    class="step-tips-item"
                    v-for="(tips, tIndex) in item.stepTips[sIndex]"
                    :key="tIndex"
                  >
                    {{ tips }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="section section3">
        <div class="section3-content">
          <div class="section-title">
            {{ translateTitle("透明性报告") }}
          </div>
          <div class="section-subTitle">
            {{
              translateTitle(
                "我们每年披露执法请求数据：请求数量、类型、处理结果、平均响应时间。"
              )
            }}
          </div>
          <div class="download-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="16"
              viewBox="0 0 18 16"
              fill="none"
            >
              <path
                d="M9.3463 2.16667H16.5013C16.7223 2.16667 16.9343 2.25446 17.0906 2.41074C17.2468 2.56702 17.3346 2.77899 17.3346 3V14.6667C17.3346 14.8877 17.2468 15.0996 17.0906 15.2559C16.9343 15.4122 16.7223 15.5 16.5013 15.5H1.5013C1.28029 15.5 1.06833 15.4122 0.912046 15.2559C0.755766 15.0996 0.667969 14.8877 0.667969 14.6667V1.33333C0.667969 1.11232 0.755766 0.900358 0.912046 0.744078C1.06833 0.587797 1.28029 0.5 1.5013 0.5H7.67964L9.3463 2.16667ZM2.33464 2.16667V13.8333H15.668V3.83333H8.6563L6.98963 2.16667H2.33464ZM9.83464 8.83333H12.3346L9.0013 12.1667L5.66797 8.83333H8.16797V5.5H9.83464V8.83333Z"
                fill="white"
              />
            </svg>
            {{ translateTitle("下载最新报告") }}
          </div>
        </div>
      </div> -->
      <div class="section section7">
        <div class="section-title">
          {{ translateTitle("合规与用户保护") }}
        </div>
        <div class="section-subTitle gray">
          {{ translateTitle("我们不仅服务于合规监管，更致力于用户权益保护：") }}
        </div>
        <ul class="section7-items">
          <li
            v-for="(item, index) in section7Items"
            :key="index"
            class="section7-item"
          >
            {{ item }}
          </li>
        </ul>
      </div>
      <!-- <div class="section section6">
        <div class="section-title center">
          {{ translateTitle("用户保护FAQ") }}
        </div>
        <div class="faqs">
          <el-collapse v-model="activeNames">
            <el-collapse-item
              v-for="(item, index) in faqs"
              :title="item.title"
              :name="index.toString()"
              :key="index"
            >
              <template #icon>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                    fill="black"
                  />
                  <path
                    d="M12 6C12.4142 6 12.75 6.33579 12.75 6.75V11.25H17.25C17.6642 11.25 18 11.5858 18 12C18 12.4142 17.6642 12.75 17.25 12.75H12.75V17.25C12.75 17.6642 12.4142 18 12 18C11.5858 18 11.25 17.6642 11.25 17.25V12.75H6.75C6.33579 12.75 6 12.4142 6 12C6 11.5858 6.33579 11.25 6.75 11.25H11.25V6.75C11.25 6.33579 11.5858 6 12 6Z"
                    fill="black"
                  />
                </svg>
              </template>
              <div>
                {{ item.content }}
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div> -->
      <div class="section section4">
        <div class="section-title center">
          {{ translateTitle("法律文件") }}
        </div>
        <div class="files">
          <div
            v-for="(item, index) in files"
            :key="index"
            class="file"
            @click="() => openUrl(item.url())"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <g clip-path="url(#clip0_132663_546)">
                <path
                  d="M17.6794 3.49305C17.5503 3.37276 17.4061 3.23876 17.2503 3.09446C16.8051 2.68209 16.3562 2.26968 15.9316 1.88453C15.8837 1.84105 15.8837 1.84105 15.8357 1.7976C15.2692 1.28479 14.7967 0.866729 14.4475 0.572141C14.2432 0.399787 14.0824 0.270717 13.9643 0.185581C13.8858 0.129074 13.8221 0.0883739 13.7592 0.0585686C13.68 0.021033 13.6062 -0.0018365 13.5021 0.000115789C13.2235 0.00533886 13 0.22987 13 0.511381V1.5108V2.51021V4.50905V5.00875H13.5H17.5L17 4.50905V19.5003L17.5 19.0006H4.49964C3.67 19.0006 3 18.3325 3 17.504V0.511381L2.5 1.01109H13.5C13.7761 1.01109 14 0.787363 14 0.511381C14 0.2354 13.7761 0.0116732 13.5 0.0116732H2.5H2V0.511381V17.504C2 18.885 3.11822 20 4.49964 20H17.5H18V19.5003V4.50905V4.00934H17.5H13.5L14 4.50905V2.51021V1.5108V0.511381C14 0.777613 13.7841 0.994419 13.5209 0.999356C13.4318 1.00103 13.3803 0.985078 13.3306 0.961547C13.3254 0.959056 13.3466 0.97259 13.3795 0.996294C13.4723 1.06313 13.6161 1.17861 13.8025 1.33582C14.1408 1.62127 14.6058 2.03267 15.1643 2.53831C15.2119 2.58141 15.2119 2.58141 15.2595 2.62454C15.6812 3.00711 16.1277 3.41727 16.5706 3.82747C16.7256 3.97106 16.8691 4.10439 16.9975 4.22402C17.0744 4.29573 17.1293 4.34699 17.1582 4.37405C17.3597 4.56271 17.6762 4.55237 17.8649 4.35094C18.0537 4.14952 18.0433 3.83329 17.8418 3.64463C17.8121 3.61685 17.7569 3.56529 17.6794 3.49305ZM2 9.00642H0V17.5015H10H20V9.00642H3V8.99475H2V9.00642ZM4.06641 13.8867V16H3.07812V10.3125H5.25391C5.88933 10.3125 6.39388 10.4779 6.76758 10.8086C7.14128 11.1393 7.32812 11.5768 7.32812 12.1211C7.32812 12.6784 7.14518 13.112 6.7793 13.4219C6.41341 13.7318 5.90104 13.8867 5.24219 13.8867H4.06641ZM4.06641 13.0938H5.25391C5.60547 13.0938 5.8737 13.0111 6.05859 12.8457C6.24349 12.6803 6.33594 12.4414 6.33594 12.1289C6.33594 11.8216 6.24219 11.5762 6.05469 11.3926C5.86719 11.209 5.60938 11.1146 5.28125 11.1094H4.06641V13.0938ZM8.19141 16V10.3125H9.87109C10.3737 10.3125 10.8197 10.4245 11.209 10.6484C11.5983 10.8724 11.8997 11.1901 12.1133 11.6016C12.3268 12.013 12.4336 12.4844 12.4336 13.0156V13.3008C12.4336 13.8398 12.3262 14.3138 12.1113 14.7227C11.8965 15.1315 11.5905 15.4466 11.1934 15.668C10.7962 15.8893 10.3411 16 9.82812 16H8.19141ZM9.17969 11.1094V15.2109H9.82422C10.3425 15.2109 10.7402 15.0488 11.0176 14.7246C11.2949 14.4004 11.4362 13.9349 11.4414 13.3281V13.0117C11.4414 12.3945 11.3073 11.9232 11.0391 11.5977C10.7708 11.2721 10.3815 11.1094 9.87109 11.1094H9.17969ZM16.6953 13.5898H14.4062V16H13.418V10.3125H17.0312V11.1094H14.4062V12.8008H16.6953V13.5898Z"
                  fill="#5E5E5E"
                />
                <path
                  d="M2 9.00386H0V17.4989H10H20V9.00386H3V8.99219H2V9.00386Z"
                  fill="#D93838"
                />
                <path
                  d="M3.98828 14.0664V16.1797H3V10.4922H5.17578C5.8112 10.4922 6.31575 10.6576 6.68945 10.9883C7.06315 11.319 7.25 11.7565 7.25 12.3008C7.25 12.8581 7.06706 13.2917 6.70117 13.6016C6.33528 13.9115 5.82292 14.0664 5.16406 14.0664H3.98828ZM3.98828 13.2734H5.17578C5.52735 13.2734 5.79557 13.1908 5.98047 13.0254C6.16537 12.86 6.25781 12.6211 6.25781 12.3086C6.25781 12.0013 6.16406 11.7559 5.97656 11.5723C5.78906 11.3887 5.53125 11.2943 5.20312 11.2891H3.98828V13.2734ZM8.11328 16.1797V10.4922H9.79297C10.2956 10.4922 10.7415 10.6042 11.1309 10.8281C11.5202 11.0521 11.8216 11.3698 12.0352 11.7812C12.2487 12.1927 12.3555 12.6641 12.3555 13.1953V13.4805C12.3555 14.0195 12.248 14.4935 12.0332 14.9023C11.8184 15.3112 11.5124 15.6263 11.1152 15.8477C10.7181 16.069 10.263 16.1797 9.75 16.1797H8.11328ZM9.10156 11.2891V15.3906H9.74609C10.2643 15.3906 10.6621 15.2285 10.9395 14.9043C11.2168 14.5801 11.3581 14.1146 11.3633 13.5078V13.1914C11.3633 12.5742 11.2292 12.1029 10.9609 11.7773C10.6927 11.4518 10.3034 11.2891 9.79297 11.2891H9.10156ZM16.6172 13.7695H14.3281V16.1797H13.3398V10.4922H16.9531V11.2891H14.3281V12.9805H16.6172V13.7695Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_132663_546">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="section section5">
        <div class="section-title center">
          {{ translateTitle("合作机构") }}
        </div>
        <div class="section-subTitle center gray">
          {{
            translateTitle("多种三方专业权威机构合作，为您的资金安全保驾护航")
          }}
        </div>
        <div class="orgs">
          <div v-for="(item, index) in orgs" :key="index" class="org">
            <img :src="item" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import commonMixin from "@/components/common/commonMixin.vue";
import routeSplicing from "@/assets/js/routeSplicing";
import { mapGetters } from "vuex";
import banner from "@/assets/img/law/banner.png";
export default {
  computed: {
    ...mapGetters({
      userInfo: "user/userInfo",
      language: "user/language",
    }),
  },
  mixins: [commonMixin],
  data() {
    return {
      activeNames: [0],
      banner,
      section7Items: [
        this.translateTitle("反洗钱与反恐融资（AML/CFT）政策"),
        this.translateTitle("了解你的客户（KYC）流程"),
        this.translateTitle("用户资产安全保障措施"),
        this.translateTitle("数据隐私与信息安全"),
        this.translateTitle("合规培训与内部审计机制"),
      ],
      actions: [
        {
          icon: require("@/assets/img/law/a1.png"),
          title: this.translateTitle("提交渠道"),
          steps: [
            // this.translateTitle(
            //   "默认渠道 ：通过 Kodex Portal 统一提交（需认证执法身份）"
            // ),
            this.translateTitle("请使用政府域邮箱将执法请求发送到") +
              " legal@maskex.com",
          ],
          stepTips: {
            0: [
              this.translateTitle("邮件内请提供"),
              this.translateTitle("1. 法院命令、传票或其他正式法律文书"),
              this.translateTitle(
                "2. 案件摘要及目标说明（包括涉及账户、钱包地址、交易哈希TXID）"
              ),
              this.translateTitle("3. 必须使用英文或附上认证翻译件"),
            ],
          },
        },
        {
          icon: require("@/assets/img/law/a2.png"),
          title: this.translateTitle("处理原则"),
          steps: [
            this.translateTitle("仅限执法机构"),
            this.translateTitle("逐案审查"),
            this.translateTitle("用户隐私优先"),
            this.translateTitle("跨境需 MLAT"),
            this.translateTitle("定期发布透明度报告"),
          ],
        },
      ],
      faqs: [
        {
          title: this.translateTitle("MaskEx 是否受监管？"),
          content: this.translateTitle(
            "MaskEx 在多个司法辖区依法注册运营，部分示例：\n1. 阿布扎比：注册为 ADGM\n2. 美国：FinCEN MSB 注册\n3. 加拿大：注册为 MSB"
          ),
        },
        {
          title: this.translateTitle("MaskEx 如何保护用户资金？"),
          content: this.translateTitle(
            "MaskEx 采用多重安全措施保护用户资金，包括冷钱包存储、多重签名技术和定期安全审计等。"
          ),
        },
        {
          title: this.translateTitle("MaskEx 如何处理执法请求？"),
          content: this.translateTitle(
            "MaskEx 遵守适用法律法规，严格评 估每个执法请求，确保用户隐私和权益得到保护。MaskEx 遵守适用法律法规，严格评 估每个执法请求，确保用户隐私和权益得到保护。MaskEx 遵守适用法律法规，严格评 估每个执法请求，确保用户隐私和权益得到保护。MaskEx 遵守适用法律法规，严格评 估每个执法请求，确保用户隐私和权益得到保护。MaskEx 遵守适用法律法规，严格评 估每个执法请求，确保用户隐私和权益得到保护。"
          ),
        },
      ],
      orgs: [
        require("@/assets/img/law/o1.png"),
        require("@/assets/img/law/o2.png"),
        require("@/assets/img/law/o3.png"),
        require("@/assets/img/law/o4.png"),
        require("@/assets/img/law/o5.png"),
        require("@/assets/img/law/o6.png"),
        require("@/assets/img/law/o7.png"),
        require("@/assets/img/law/o8.png"),
        require("@/assets/img/law/o9.png"),
        require("@/assets/img/law/o10.png"),
      ],
      privacyUrl: "",
      files: [
        {
          name: this.translateTitle("《服务协议》"),
          url: () => {
            const langMap = {
              zh_CN:
                "https://help-center.maskex.com/#/category?lang=zh-CN&articleId=91b639cb-4a7c-41dd-9be1-a759199d4ace&code=NOTICE%3ANews&showContent=true",
              en: "https://help-center.maskex.com/#/category?lang=en&code=NOTICE%3ANews&showContent=true&articleId=d9c45cf1-6b85-4b5b-8eeb-f80d93a845ee",
            };
            return langMap[this.language] || langMap.en;
          },
        },
        // {
        //   name: this.translateTitle("《隐私政策》"),
        //   // url: () => {
        //   //   return this.privacyUrl;
        //   // },
        //   url: () => {
        //     const langMap = {
        //       zh_CN:
        //         "https://help-center.maskex.com/#/category?lang=zh-CN&articleId=adfbb888-6feb-4b04-ae40-7fb132ddbade&code=NOTICE%3ANews&showContent=true",
        //       en: "https://help-center.maskex.com/#/category?lang=en&articleId=68d8e8c8-329e-4282-ac2e-28fd8a747c06&code=NOTICE%3ANews&showContent=true",
        //     };
        //     return langMap[this.language] || langMap.en;
        //   },
        // },
        {
          name: this.translateTitle("《免责声明》"),
          url: () => {
            const langMap = {
              zh_CN:
                "https://help-center.maskex.com/#/category?lang=zh-CN&articleId=adfbb888-6feb-4b04-ae40-7fb132ddbade&code=NOTICE%3ANews&showContent=true",
              en: "https://help-center.maskex.com/#/category?lang=en&articleId=68d8e8c8-329e-4282-ac2e-28fd8a747c06&code=NOTICE%3ANews&showContent=true",
            };
            return langMap[this.language] || langMap.en;
          },
        },
        {
          name: this.translateTitle("《风险披露声明》"),
          url: () => {
            const langMap = {
              zh_CN:
                "https://help-center.maskex.com/#/category?lang=zh-CN&articleId=0f3f7127-f52a-4726-b601-abba934bc079&code=NOTICE%3ANews&showContent=true",
              en: "https://help-center.maskex.com/#/category?lang=en&articleId=3eb1235d-0762-4e9f-8bf5-d4413a24e475&code=NOTICE%3ANews&showContent=true",
            };
            return langMap[this.language] || langMap.en;
          },
        },
        {
          name: this.translateTitle("《受限地区清单》"),
          url: () => {
            const langMap = {
              zh_CN:
                "https://help-center.maskex.com/#/category?lang=zh-CN&articleId=332a6216-abf3-409b-8843-e2bd4a98dd23&code=NOTICE%3ANews&showContent=true",
              en: "https://help-center.maskex.com/#/category?lang=en&articleId=79ccc21e-1ad8-42f7-ad5b-9e31885637cd&code=NOTICE%3ANews&showContent=true",
            };
            return langMap[this.language] || langMap.en;
          },
        },
      ],
      cards: [
        {
          country: this.translateTitle("阿布扎比"),
          cIcon: require("@/assets/img/law/c1.png"),
          name: this.translateTitle("注册为 ADGM"),
          mIcon: require("@/assets/img/law/m1.png"),
        },
        // {
        //   country: this.translateTitle("美国"),
        //   cIcon: require("@/assets/img/law/c2.png"),
        //   name: this.translateTitle("FinCEN MSB 注册"),
        //   mIcon: require("@/assets/img/law/m2.png"),
        // },
        {
          country: this.translateTitle("加拿大"),
          cIcon: require("@/assets/img/law/c3.png"),
          name: this.translateTitle("注册为 MSB"),
          mIcon: require("@/assets/img/law/m3.png"),
        },
      ],
    };
  },
  watch: {},
  created() {
    this.logImg = require("../../assets/img/mask-logo.png");
    this.slogan = JSON.parse(sessionStorage.getItem("solgan"));

    if (!JSON.parse(sessionStorage.getItem("clause"))) {
      getEnv();
    }
    let clauseList = JSON.parse(sessionStorage.getItem("clause"));
    let othersList = JSON.parse(sessionStorage.getItem("others"));
    let noticeList = JSON.parse(sessionStorage.getItem("zendesk_notice"));
    let qrcode = JSON.parse(sessionStorage.getItem("qrcode"));
    let about = JSON.parse(sessionStorage.getItem("about"));

    this.privacyUrl = clauseList[1].url;
    this.statementUrl = clauseList[2].url;
    // this.serviceUrl = clauseList[0].url;
    this.rateUrl = othersList[0].url;
    this.tipUrl = about[0].url;
    this.helpUrl = `https://help-center.maskex.com/#/?lang=${this.language}`; // about[1].url;
    this.tgUrl = qrcode.ori_url;
    this.qrcodeTitle = qrcode.title;
  },
  mounted() {},
  methods: {
    routeSplicing,
    openUrl: function (url) {
      if (!url) return;
      window.open(url, "_blank");
    },
  },
  destroyed() {},
};
</script>
<style lang="scss" >
.law-container {
  .el-collapse-item__header {
    color: #15192a;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 90% */
    padding-left: 30px;
    height: auto;
    padding-top: 25px;
    padding-bottom: 25px;
  }
  .el-collapse-item__content {
    padding-left: 30px;
    font-size: 16px;
  }
  /* .el-icon-arrow-right:before {
    content: "\e6d9";
  }
  .el-icon-arrow-right.is-active:before {
    content: "\e7a2";
  } */
}
</style>
<style lang="scss" scoped>
.law-container {
  --c-width: 1200px;

  .banner {
    height: 504px;
    background: linear-gradient(180deg, #e7fbfc 0%, #f7f9fc 100%);
    &-content {
      width: var(--c-width);
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      display: flex;
      justify-content: space-between;
      gap: 146px;
      &-text {
        width: 554px;
        &-title {
          color: #15192a;
          font-size: 40px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }
        &-subTitle {
          color: #15192a;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 44px; /* 183.333% */
        }
      }
      &-img {
        > img {
          width: 367px;
          height: 370px;
          flex-shrink: 0;
          aspect-ratio: 367/370;
        }
      }
    }
  }
  .section-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    .section {
      width: var(--c-width);
      padding-top: 58px;
      padding-bottom: 58px;

      &-title {
        color: #15192a;
        font-size: 36px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        &.center {
          text-align: center;
        }
      }
      &-subTitle {
        margin-top: 12px;
        color: #000;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        &.center {
          text-align: center;
        }
        &.gray {
          color: var(--web-w--2, #75777a);
        }
      }
      &.section1 {
        .cards {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
          margin-top: 32px;
          .card {
            border-radius: 8px;
            border: 1px solid var(--web-w-bg--, #eaecef);
            background: var(--web-w-bg-, #fff);
            padding: 50px 0;
            &-name {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              > img {
                width: 220px;
                margin-bottom: 24px;
              }
            }
            &-country {
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 10px;
              margin-bottom: 23px;
              > img {
                width: 21.991px;
                flex-shrink: 0;
              }
              .card-country-name {
                color: #15192a;
                text-align: center;
                font-size: 20px;
                font-style: normal;
                font-weight: 500;
                line-height: 16px; /* 80% */
              }
            }
          }
        }
      }
      &.section2 {
        .actions {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
          margin-top: 44px;
          .action {
            padding: 20px 60px;
            border-radius: 8px;
            border-bottom: 4px solid var(--Linear, #0084d5);
            background: #f7f9fc;
            &-title {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              color: var(--web-w--1, #151519);
              font-size: 24px;
              font-style: normal;
              font-weight: 600;
              line-height: normal;
              padding-bottom: 20px;
              border-bottom: 1px solid var(--web-w-bg-, #e5e9ee);
              > img {
                width: 79.989px;
                flex-shrink: 0;
              }
            }
            .steps {
              margin-top: 30px;
              margin-bottom: 40px;
              .step {
                // display: flex;
                align-items: center;
                gap: 28px;
                padding-top: 12px;
                padding-bottom: 20px;
                position: relative;
                padding-left: 32px;
                color: var(--App-w--1, #151519);
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: 20px; /* 125% */
                &-icon {
                  position: absolute;
                  left: 0;
                  z-index: 111;
                }
                &::before {
                  content: "";
                  position: absolute;
                  left: 8px;
                  top: 0;
                  bottom: 0px;
                  border-left: 1px dashed #8e9196;
                  z-index: 1;
                }
                .step-tips {
                  margin-top: 16px;
                  font-size: 14px;
                  color: #8e9196;
                }
              }
            }
          }
        }
      }
      &.section3 {
        width: 100%;
        background: #f7f9fc;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .section3-content {
          width: var(--c-width);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        .download-btn {
          border-radius: 6px;
          margin-top: 40px;
          cursor: pointer;
          background: var(
            --Linear,
            linear-gradient(270deg, #0084d5 0%, #03cf87 100%)
          );
          color: var(--web-w-T-, #fff);
          text-align: center;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 21px; /* 131.25% */
          padding: 14px 60px;
          display: flex;
          align-items: center;
          gap: 6px;
        }
      }
      &.section4 {
        .files {
          margin-top: 30px;
          display: flex;
          gap: 40px;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          .file {
            cursor: pointer;
            display: flex;
            gap: 2px;
            align-items: center;
            color: var(--web-w--1, #151519);
            font-size: 20px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px; /* 90% */
          }
        }
      }
      &.section5 {
        .orgs {
          margin-top: 30px;
          display: grid;
          gap: 16px;
          grid-template-columns: repeat(5, 1fr);
          .org {
            border-radius: 8px;
            background: var(--web-w-bg-, #f3f4f6);
            padding: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            > img {
              height: 40px;
              object-fit: contain;
            }
          }
        }
      }
      &.section6 {
        .faqs {
          margin-top: 40px;
        }
      }
      &.section7 {
        .section7-items {
          margin-top: 20px;
          padding-left: 18px;
          .section7-item {
            color: var(--web-w--1, #15192a);
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 48px; /* 300% */
            word-break: break-all;
            list-style: disc;
          }
        }
      }
    }
  }
}
</style>
